// extracted by mini-css-extract-plugin
export default {"error":"Input_error__r6Y+6","inputUpdatePassWrapper":"Input_inputUpdatePassWrapper__OG9Tw","registration__sectionField":"Input_registration__sectionField__wbSwt"};